import { Controller } from '@hotwired/stimulus'
import type { App } from 'vue'
import type { AsyncRenderErrorReason } from '@app/templates/components/async-render-error.types'
import { createApp } from '@app/adapters/create-app'
import AsyncRenderError from '@app/templates/components/async-render-error.vue'

const LIQUID_TIMEOUT_EVENT = 'sf-live-inputs:asyncRenderTimeout'

// Mounts the template error screen into its element. A Liquid async render
// opens it through the live inputs timeout event, and a Solid template opens
// it as an outlet of the solid-app controller.
export default class extends Controller {
  static values = {
    reason: { type: String, default: 'too_much_data' },
    canBeDeleted: Boolean,
    reviewPath: String,
    url: String,
    message: String,
    confirmationName: String,
  }

  declare readonly reasonValue: AsyncRenderErrorReason
  declare readonly canBeDeletedValue: boolean
  declare readonly reviewPathValue: string
  declare readonly urlValue: string
  declare readonly messageValue: string
  declare readonly confirmationNameValue: string

  private app: App | null = null

  connect(): void {
    window.eventHub.$on(LIQUID_TIMEOUT_EVENT, this.show)
  }

  disconnect(): void {
    window.eventHub.$off(LIQUID_TIMEOUT_EVENT, this.show)
    this.app?.unmount()
    this.app = null
  }

  show = (): void => {
    if (this.app) {
      return
    }

    this.app = createApp(AsyncRenderError, {
      reason: this.reasonValue,
      canBeDeleted: this.canBeDeletedValue,
      reviewPath: this.reviewPathValue,
      url: this.urlValue,
      message: this.messageValue,
      confirmationName: this.confirmationNameValue,
    })
    this.app.mount(this.element)
  }
}
